import { fetchPosters, updatePoster, deletePoster } from '../../services/apiClient.js';
import { ANONYMOUS_CREATOR, normalizePseudo } from '../posters/posterInfo.js';

// Posters validés sur la page Posters : même gestion que les photos sphère
// (miniature légère, téléchargement HD en PNG ou JPEG, masquer, supprimer).
// "Pseudo" = créateur du poster, modifiable (vide : "Anonyme").
export function createPosterDashboardFeature() {
  let rows = [];
  const posterList    = document.getElementById('posterList');
  const posterEmpty   = document.getElementById('posterEmpty');
  const posterCardTpl = document.getElementById('posterCardTpl');

  function createPosterCard(poster) {
    const frag = posterCardTpl.content.cloneNode(true);
    const li   = frag.querySelector('.photo-card');

    li.querySelector('.photo-thumb').src = `/api/posters/${poster.id}/image?size=thumb`;
    li.querySelector('.poster-download-png').href = poster.downloads.png;
    li.querySelector('.poster-download-jpg').href = poster.downloads.jpg;

    const contributors = Array.isArray(poster.contributors) ? poster.contributors : [];
    const contributorsEl = li.querySelector('.poster-card-contributors');
    contributorsEl.textContent = contributors.length ? `avec ${contributors.join(', ')}` : '';
    contributorsEl.title = contributorsEl.textContent;

    // Masquer : retiré d'Escales, gardé en base et sur S3 -- réversible,
    // contrairement à la suppression.
    const btnHide = li.querySelector('.photo-hide');
    function showHidden() {
      li.classList.toggle('photo-card--hidden', poster.hidden);
      btnHide.textContent = poster.hidden ? 'Afficher' : 'Masquer';
      btnHide.title       = poster.hidden ? 'Remettre le poster sur le site' : 'Retirer le poster du site sans le supprimer';
    }
    showHidden();
    btnHide.addEventListener('click', async () => {
      const hidden = !poster.hidden;
      btnHide.disabled = true;
      try {
        const res = await updatePoster(poster.id, { hidden });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        poster.hidden = hidden;
        showHidden();
      } catch (err) {
        console.error('Erreur masquage poster:', err);
      } finally {
        btnHide.disabled = false;
      }
    });

    li.querySelector('.photo-date').textContent = new Date(poster.createdAt)
      .toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });

    const pseudoEl      = li.querySelector('.dash-pseudo');
    const btnEditPseudo = li.querySelector('.dash-btn--edit-pseudo');

    function showPseudoText() {
      pseudoEl.textContent = poster.pseudo || ANONYMOUS_CREATOR;
      pseudoEl.title       = poster.pseudo || '';
      pseudoEl.hidden      = false;
      btnEditPseudo.hidden = false;
    }

    function showPseudoInput() {
      pseudoEl.hidden      = true;
      btnEditPseudo.hidden = true;
      const inp = document.createElement('input');
      inp.type           = 'text';
      inp.className      = 'dash-pseudo-input';
      inp.placeholder    = '@pseudo';
      inp.autocapitalize = 'none';
      inp.value          = poster.pseudo || '';
      li.querySelector('.dash-pseudo-row').insertBefore(inp, pseudoEl);

      let committed = false;
      function commit() {
        if (committed) return;
        committed = true;
        inp.remove();
        // Champ vidé : poster anonyme.
        poster.pseudo = normalizePseudo(inp.value);
        updatePoster(poster.id, { pseudo: poster.pseudo }).catch(err => console.error('Erreur pseudo poster:', err));
        showPseudoText();
      }
      inp.addEventListener('blur', commit);
      inp.addEventListener('keydown', e => {
        if (e.key === 'Enter') { e.preventDefault(); inp.blur(); }
      });
      inp.focus();
    }

    showPseudoText();
    btnEditPseudo.addEventListener('click', showPseudoInput);

    li.querySelector('.photo-delete').addEventListener('click', async () => {
      li.classList.add('dash-card--removing');
      li.addEventListener('animationend', async () => {
        try {
          await deletePoster(poster.id);
          rows = rows.filter(p => p.id !== poster.id);
          li.remove();
          posterEmpty.hidden = rows.length > 0;
        } catch (err) {
          console.error('Erreur suppression poster:', err);
        }
      }, { once: true });
    });

    li.dataset.id = poster.id;
    return li;
  }

  async function load() {
    try {
      rows = await fetchPosters({ includeHidden: true });
      posterList.innerHTML = '';
      posterEmpty.hidden   = rows.length > 0;
      for (const poster of rows) {
        posterList.appendChild(createPosterCard(poster));
      }
    } catch (err) {
      console.error('Erreur chargement posters:', err);
    }
  }

  return { load };
}
